<section>
   <div class="slider-container">
      <h1 id="your-life">GOLF</h1>
      <h1 id="your-way">MOBILE</h1>
   </div>
</section>